export default {
  // Grey general note (restored per PM video) — the full one-per-order rule, shown on the
  // offer sheet and the promo/gift modal. Automatic discounts (smart pricing) still stack.
  general_note:
    'Códigos promo e cartões oferta não podem ser combinados com outros descontos. Uma oferta e pontos podem ser usados em conjunto. Descontos automáticos como o desconto de takeaway continuam a aplicar-se.',
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: 'Códigos promo e cartões oferta não podem ser combinados com outros descontos.',
  // Green status pill on the offer sheet when the offer's requirement is met (prototype).
  unlocked: 'Desbloqueado',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'Não pode ser combinado com códigos promo ou cartões oferta.',
    promo: 'Não pode ser combinado com ofertas, cartões oferta ou pontos.',
    gift: 'Não pode ser combinado com ofertas, códigos promo ou pontos.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'Existe um código promo aplicado. Aplicar esta oferta irá removê-lo.',
    offer_blocked_by_gift: 'Existe um cartão oferta aplicado. Aplicar esta oferta irá removê-lo.',
    offer_blocked_by_points: 'Existe uma utilização de pontos ativa. Aplicar esta oferta irá removê-la.',
    promo_gift_displaces_offer: 'Aplicar um código promo ou cartão oferta irá remover a sua oferta ativa.',
    promo_gift_displaces_points: 'Aplicar um código promo ou cartão oferta irá remover a sua utilização de pontos.',
    promo_gift_displaces_offer_and_points:
      'Aplicar um código promo ou cartão oferta irá remover a sua oferta ativa e a utilização de pontos.',
  },
  // Comparison-choice card (Inc 4, FOO-2567) — offer / promo detail modals when a conflicting
  // discount is already applied. Lets the customer pick, flagging the higher saving as best.
  comparison: {
    active_line: 'Este {{kind}} já está ativo: {{name}} ({{saving}}).',
    active_line_no_saving: 'Este {{kind}} já está ativo: {{name}}.',
    candidate_line: 'O {{kind}} poupa {{saving}}.',
    only_one: 'Só pode utilizar um.',
    best_choice: 'Melhor opção',
    keep: 'Manter {{label}}',
    use_instead: 'Usar {{label}} em alternativa',
    kinds: {
      offer: 'oferta',
      promo: 'código promo',
      gift: 'cartão oferta',
      points: 'utilização de pontos',
    },
    // Concise nouns for the Keep/Use buttons ("Keep offer", "Use code instead").
    button_kinds: {
      offer: 'oferta',
      promo: 'código',
      gift: 'cartão oferta',
      points: 'pontos',
    },
    // Single-action variant (offer modal, promo/gift already active): one sentence + only the
    // "Use offer instead" button — closing the window keeps the code (CTO 2026-08-03).
    single_message:
      '{{active}} já está ativo. Só pode ser utilizado um desconto por pedido — use esta oferta em alternativa ou feche esta janela para manter o seu código.',
    active_named: {
      promo: 'Código promo {{name}} ({{saving}})',
      gift: 'Cartão oferta ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Código promo {{name}}',
      gift: 'Cartão oferta',
    },
    // Multiple active offers (item 6) — promo modal comparison, replaces the active/candidate lines.
    active_offers_two:
      'Tem {{count}} ofertas ativas: {{first}} ({{firstValue}}) e {{second}} ({{secondValue}}) — {{total}} no total. O código promo {{code}} poupa {{codeValue}} neste pedido. Só pode ser usado um.',
    active_offers_more:
      'Tem {{count}} ofertas ativas: {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) e {{more}} mais — {{total}} no total. O código promo {{code}} poupa {{codeValue}} neste pedido. Só pode ser usado um.',
  },
  // Discount-card status tag (deals carousel — offer + promo cards), Inc 3.
  card: {
    available: 'Disponível agora',
    applied: 'Aplicado · {{savings}} de desconto',
    applied_plain: 'Aplicado',
    replaces: 'Não combinável com {{label}} · Substitui {{name}}',
    replaces_no_name: 'Não pode ser combinado com {{label}}',
    // Prototype card treatment (blocked-by-conflict): a warning line naming the active discount,
    // the one-per-order note, and a "Replaces …" line.
    cannot_combine: 'Não pode ser combinado com {{name}}',
    replaces_name: 'Substitui {{name}}',
    // Multiple active offers (n>1) — show a count + total instead of a single offer name (item 6).
    cannot_combine_offers: 'Não combinável com as suas {{count}} ofertas ativas',
    replaces_offers: 'Substitui {{count}} ofertas ativas ({{total}})',
    // Generic type label for the active discount that would be displaced.
    kind: {
      offer: 'uma oferta',
      promo: 'um código promo',
      gift: 'um cartão oferta',
      points: 'a sua utilização de pontos',
    },
  },
  // DisplacementNotice (cart drawer + checkout) — bidirectional & entity-named (PM video).
  // One discount displaced another; the message names both, and Undo restores the displaced one.
  // e.g. "Promo code CHEVERE applied. This removed the 2-für-1 offer. [Undo]".
  displacement: {
    message: '{{applied}} aplicado. Isto removeu {{removed}}.',
    // Multiple offers removed at once (item 6) — names the top two + the total, in cart + checkout.
    offer_removed_multi: {
      promo:
        'Código promo {{code}} ({{codeValue}}) aplicado. Isto removeu {{count}} ofertas: {{first}} e {{second}} ({{total}}).',
      gift: 'Cartão oferta aplicado. Isto removeu {{count}} ofertas: {{first}} e {{second}} ({{total}}).',
    },
    undo: 'Desfazer',
    // The discount that is currently applied (the "winner").
    applied: {
      offer: 'Oferta {{name}}',
      promo: 'Código promo {{code}}',
      gift: 'Cartão oferta',
      points: '{{count}} pontos',
    },
    // The discount that was displaced (the "loser"), restored by Undo.
    removed: {
      offer: 'a oferta {{name}}',
      promo: 'o código promo {{code}}',
      gift: 'o cartão oferta',
      points: 'a sua utilização de pontos',
    },
    // UX feedback item 3 — points redemption displacing a promo/gift. Layer A: a zero-friction hint
    // under the "Use your points" header, shown only while a code/gift is active (before they tap).
    points_hint: {
      promo: 'Usar pontos irá remover o código promo {{name}} (–{{saving}})',
      gift: 'Usar pontos irá remover o cartão oferta (–{{saving}})',
      promo_no_saving: 'Usar pontos irá remover o código promo {{name}}',
      gift_no_saving: 'Usar pontos irá remover o cartão oferta',
    },
    // Layer B: the post-action displacement notice, extended to the points→code direction.
    points_displaced: {
      promo:
        '{{points}} pontos aplicados (–{{pointsSaving}}). O código promo {{name}} (–{{couponSaving}}) foi removido.',
      gift: '{{points}} pontos aplicados (–{{pointsSaving}}). O cartão oferta (–{{couponSaving}}) foi removido.',
      promo_no_saving: '{{points}} pontos aplicados (–{{pointsSaving}}). O código promo {{name}} foi removido.',
      gift_no_saving: '{{points}} pontos aplicados (–{{pointsSaving}}). O cartão oferta foi removido.',
    },
  },
};
